(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.SalesCoachJD",
            {
                url: "/SalesCoachJD",
                component: "salescoachjd",
                PageTitle: "Sales Coach - Jim Dunn",
                requiredPermissions: "SalesCoachJd:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }],
                    purchased: ["purchaseApi", "userApi", function (purchaseApi, userApi) {
                        var o = null;
                        return userApi.getLoggedInUser().then(function (user) {
                            return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                                ng.forEach(orders, function (order) {
                                    if (order.MarketingStrategy === "SalesCoachJimDunn") {
                                        var d = new Date(order.CompletedDate);
                                        var n = d.toLocaleDateString();
                                        order.PurchaseDate = n;

                                        purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                            if (strategy.DocusignUrl != null)
                                                order.DocusignUrl = strategy.DocusignUrl;

                                            if (strategy.Image != null)
                                                order.Image = strategy.Image;
                                        });
                                        o = order;
                                    }
                                });
                                return o;
                            });
                        });
                    }]
                }
            });
        }
    ]);

    app.component("salescoachjd",
        {
            templateUrl: "App/Resources/SalesCoachJD/SalesCoach.html",
            controller: salesCoachCtrl,
            bindings: {
                states: "<",
                purchased: "<"
            }
        });

    salesCoachCtrl.$inject = ["$mdDialog", "$filter", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "purchaseApi", "wistiaApi", "permissionService", "userApi", "$interval", "amplitudeService"];

    function salesCoachCtrl($mdDialog, $filter, eligibilityFormDialog, surveys, eligibilityFormApi, purchaseApi, wistiaApi, permissionService, userApi, $interval, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.intervals = [];

        surveys.then(function (s) {           
            eligibilityFormApi.isEnrolled(s.salesCoachJimDunnId).then(function (response) {
                $ctrl.submitted = response;
            });
        });

        $ctrl.verifyPurchased = function () {         
            var o = null;
            return userApi.getLoggedInUser().then(function (user) {
                return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                    ng.forEach(orders, function (order) {
                        if (order.MarketingStrategy === "SalesCoachJimDunn") {
                            var d = new Date(order.CompletedDate);
                            var n = d.toLocaleDateString();
                            order.PurchaseDate = n;

                            purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                if (strategy.DocusignUrl != null)
                                    order.DocusignUrl = strategy.DocusignUrl;
                                if (strategy.Image != null)
                                    order.Image = strategy.Image;
                            });
                            o = order;                      
                        }
                    });

                    if (o != null) {
                        ng.forEach($ctrl.intervals, function (interval) {
                            $interval.cancel(interval);
                        });
                        $ctrl.purchased = o;
                    } 
                });
            });
        }

        $ctrl.verifyPurchased();

        $ctrl.loadResources = function () {

            $ctrl.loadingAssets = true;
            wistiaApi.getSalesCoachJdAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);
        }

        $ctrl.closeOtherAssets = function (asset) {
            ng.forEach($ctrl.Assets, function (a, key) {
                if (a.ID !== asset.ID)
                    a.Active = false;
            });
        }

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.salesCoachJimDunnId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        // Purchase Options Modal for Sales Coach: Junior Advisor  
        $ctrl.openJuniorAdvisorPurchaseDialog = function (event) {
            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    verifyPurchased: $ctrl.verifyPurchased(),
                    title: "Sales Coach: Junior Advisor",
                    //purchaseOptions: [{ Description: "2 Hour Class / 8 Weeks (Tuesday Classes)", Amount: 1500, IsOneTimePayment: true, ClassDates: ["September 6, 2016", "September 13, 2016"] },
                    //             { Description: "4 Hour Class / 4 Weeks (Monday Classes)", Amount: 1500, IsOneTimePayment: true, ClassDates: ["October 6, 2016", "October 13, 2016"] }],
                    purchaseOptions: [{ Description: "Junior Advisor - One Time Payment", Amount: 1500, IsOneTimePayment: true }],
                    termsLink: "https://www.figmarketing.com/Documents/Terms_of_Use.pdf",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop),
                    selectedPurchaseOption: 0
                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        }, 3000)
                    );
                }
                else $ctrl.verifyPurchased();
            });
        }

        // Purchase Options Modal for Sales Coach: Advisor Model 
        $ctrl.openAdvisorModelPurchaseDialog = function (event) {
            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    verifyPurchased: $ctrl.verifyPurchased(),
                    title: "Sales Coach: Advisor Model",
                    //purchaseOptions: [{ Description: "2 Hour Class / 8 Weeks (Tuesday Classes)", Amount: 3500, IsOneTimePayment: true, ClassDates: ["September 6, 2016", "September 13, 2016"] },
                    //             { Description: "4 Hour Class / 4 Weeks (Monday Classes)", Amount: 3500, IsOneTimePayment: true, ClassDates: ["October 6, 2016", "October 13, 2016"] }],
                    purchaseOptions: [{ Description: "Advisor Model - One Time Payment", Amount: 3500, IsOneTimePayment: true }],
                    termsLink: "http://figmarketing.com/terms-of-use.aspx",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop),
                    selectedPurchaseOption: 0

                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        }, 3000)
                    );
                }
                else $ctrl.verifyPurchased();
            });
        }

        // Purchase Options Modal for Sales Coach: Agency Model 
        $ctrl.openAgencyModelPurchaseDialog = function (event) {

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    title: "Sales Coach: Agency Model",
                    purchaseOptions: [{ Description: "Agency Model - One Time Payment", Amount: 15000, IsOneTimePayment: true }],
                    termsLink: "http://figmarketing.com/terms-of-use.aspx",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop),
                    selectedPurchaseOption: 0
                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        }, 3000)
                    );
                }
                else $ctrl.verifyPurchased();
            });
        }

        if (permissionService.hasOnePermission("SalesCoachJd:Access")) {
            $ctrl.loadResources();
        }
    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window", "$state"];
    function dialogCtrl($mdDialog, purchaseApi, $window, $state) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                close: close,
                cancel: cancel,
                purchase: purchase,
                getPaymentAmount: getPaymentAmount,
                setup: setup
            });

        function setup() {
            $ctrl.selectedPurchaseOption = 0;
            $ctrl.paymentAmount = $ctrl.purchaseOptions[0].Amount;
            $ctrl.marketingDollarsToUse = 0;
        }

        $ctrl.setup();

        function getPaymentAmount() {
            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount) {
                $ctrl.marketingDollarsToUse = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount;
            }

            if ($ctrl.marketingDollarsToUse == null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount - $ctrl.marketingDollarsToUse;
        }  

        function purchase(model) {
            $ctrl.submittingOrder = true;
            $ctrl.error = false;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = "SalesCoachJimDunn";
            order.Total = $ctrl.purchaseOptions[$ctrl.selectedPurchaseOption].Amount;
            if (!!$ctrl.selectedClassDate)
                order.Description = $ctrl.title + " - " + order.Description + "- Class: " + ($ctrl.purchaseOptions[$ctrl.selectedPurchaseOption].ClassDates[$ctrl.selectedClassDate]);
            if (!!$ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].IsRecurringPayment)
                order.Frequency = "3";
            else
                order.Frequency = "0";
           
            return purchaseApi.purchase(order)
                .then(function (response) {

                    $ctrl.submittingOrder = false;
                    close($ctrl.paymentAmount);

                    if ($ctrl.paymentAmount > 0) {
                        $window.open(response, "_blank");
                        //$window.location.href = "/";
                    }
                }).catch(function (error) {
                    console.log(error);
                    $ctrl.submittingOrder = false;
                    $ctrl.error = true;
                });
        }

        function close(paymentAmount) {
            $mdDialog.hide(paymentAmount);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    };
})(window.app, window.angular); // jshint ignore:line